import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import InventoryManagementService from '../inventory-unpublished-batch/inventory-management.service';
import { UnpublishedBatchModalComponent } from 'src/app/shared/components/unpublished-batch-modal/unpublished-batch-modal.component';
import { UpdatePriceModalComponent } from 'src/app/shared/components/update-price-modal/update-price-modal.component';
import { tap } from 'rxjs/operators';
import moment from 'moment';
import { PublishBatchModalComponent } from 'src/app/shared/components/publish-batch-modal/publish-batch-modal.component';
import { Title } from '@angular/platform-browser';
import { NgIf, NgStyle, NgFor, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomInventoryDetailsContentComponent } from '../custom-inventory-details-content/custom-inventory-details-content.component';
import { UrlPipe } from '@spartacus/core';
@Component({
    selector: 'app-custom-inventory-details',
    templateUrl: './custom-inventory-details.component.html',
    styleUrls: ['./custom-inventory-details.component.scss'],
    imports: [NgIf, RouterLink, NgStyle, FormsModule, CustomInventoryDetailsContentComponent, NgFor, DecimalPipe, UrlPipe]
})
export class CustomInventoryDetailsComponent implements OnInit {
  Title='BHP Connect - Inventory Details';
  activeTab = 'active';
  inventoryTab= 'active';
  selectedSort: any = 'time:desc';
  inventoryDetails = [];
  inventoryProductData: any;
  negotiationData = [];
  acceptedOffersData = [];
  archivedData = [];
  nominationData =[];
  detailsId : string;
  enableLoader: boolean = true;
  otherLoader: boolean = false;
  featuresData = [];
  showUserProfile: any = false;
  loginData: any;
  constructor(private inventoryManagementService: InventoryManagementService, private router: Router, private activatedRoute: ActivatedRoute,
    public modalService:NgbModal,public ModalService:NgbModal,private titleService: Title) {
      const inventoryId = this.router.getCurrentNavigation()?.extras?.state?.data;
      if(inventoryId){
        this.detailsId = inventoryId;
      }else{
        this.detailsId = localStorage.getItem("inventoryDetailsId");
      }
      this.loginData = JSON.parse(sessionStorage.getItem("loginData"));
    }

  ngOnInit(): void {
    this.titleService.setTitle(this.Title);
    this.initialLoad();
  }
  getInventoryDetailsData(){
    if(this.inventoryDetails && this.inventoryDetails.length > 0){
      this.inventoryDetails.forEach((val: any)=>{
        if(val.quoteStatus === 'BID_RECEIVED' || val.quoteStatus === 'OFFER_SENT' || val.quoteStatus === 'BID_PLACED'  || val.quoteStatus === 'OFFER_RECEIVED'){
          this.negotiationData.push(val);
        }else if(val.quoteStatus === 'ACCEPTED' || val.quoteStatus === 'PICKED_UP'){
          this.acceptedOffersData.push(val);
        }else if(val.quoteStatus === 'BID_REJECTED' || val.quoteStatus === 'BID_EXPIRED' || val.quoteStatus === 'REJECTED' || val.quoteStatus === 'CANCELLED' || val.quoteStatus === 'OFFER_EXPIRED'){
          this.archivedData.push(val);
        }
        // else if(val.quoteStatus === 'BID_PLACED'){
        //   this.nominationData.push(val);
        // }
      })
    }
    if(this.nominationData && this.nominationData.length > 0) {
      this.nominationData = this.nominationData;
    }
  }
  changeTab(data, showMsg?): any {
    this.activeTab = data;
    if (this.activeTab === 'active') {
      this.inventoryTab = 'active'
    }
    else if (this.activeTab === 'completed') {
      this.inventoryTab = 'completed'
    }
    else if (this.activeTab === 'archived') {
      this.inventoryTab = 'archived'
    }
    else if (this.activeTab === 'Nomination') {
      this.inventoryTab = 'Nomination'
    }
}
convertDateOnly(dateString): any {
  if (dateString) {
    // const momentObj = moment(dateString);
    // return  momentObj.format('YY/MM/DD');
    return moment.utc(dateString).local().format('YYYY/MM/DD');
  }
}
unpublishBatch() {
  const modalRef = this.modalService.open(UnpublishedBatchModalComponent,{centered: true,size:'sm'});
  modalRef.componentInstance.code = this.inventoryProductData.code;
}
updatePricePopup(){
  const ModalRef = this.ModalService.open(UpdatePriceModalComponent,{centered: true,size:'sm'});
  ModalRef.componentInstance.code = this.inventoryProductData.code;
  ModalRef.componentInstance.price = this.inventoryProductData.price.value || '0';
  ModalRef.componentInstance.refresh.subscribe(_=>{
    this.enableLoader = true;
    this.inventoryManagementService.getInventoryDetails(this.detailsId,this.selectedSort).pipe(tap(_=>console.log(_))).subscribe((data:any) => { 
      this.inventoryProductData = data.products[0];
      this.inventoryDetails = data && data.products && data.products[0].quotes;
      this.nominationData = data && data.products && data.products[0].nominationItems ? data.products[0].nominationItems : [];
      this.featuresData = data && data.products && data.products[0].features && data.products[0].features.entry;
      this.enableLoader = false;
    });
  })
}

initialLoad(){
  this.enableLoader = true;
    this.inventoryManagementService.getInventoryDetails(this.detailsId,this.selectedSort).pipe(tap(_=>console.log(_))).subscribe((data:any) => { 
      this.inventoryProductData = data.products[0];
      this.inventoryDetails = data && data.products && data.products[0].quotes;
      this.nominationData = data && data.products && data.products[0].nominationItems ? data.products[0].nominationItems : [];
      // this.featuresData = data && data.products && data.products[0].quotes && data.products[0].quotes.features && data.products[0].quotes.features.entry;
      this.featuresData = data && data.products && data.products[0].features && data.products[0].features.entry;
      this.getInventoryDetailsData();
      this.enableLoader = false;
    });
}
selectChangeHandler(event: any): void{
  this.otherLoader = true;
  this.negotiationData = [];
  this.acceptedOffersData = [];
  this.archivedData = [];
  this.selectedSort = event.target.value;
  this.inventoryManagementService.getInventoryDetails(this.detailsId,this.selectedSort).subscribe((data:any) => { 
    this.inventoryProductData = data.products[0];
    this.inventoryDetails = data && data.products && data.products[0].quotes;
    this.nominationData = data && data.products && data.products[0].nominationItems ? data.products[0].nominationItems : [];
    // this.featuresData = data && data.products && data.products[0].quotes && data.products[0].quotes.features && data.products[0].quotes.features.entry;
    this.featuresData = data && data.products && data.products[0].features && data.products[0].features.entry;
    this.getInventoryDetailsData();
    this.otherLoader = false;
  });
}
publishBatch(){
  const ModalRef = this.ModalService.open(PublishBatchModalComponent,{centered: true,size:'sm'});
  ModalRef.componentInstance.code = this.inventoryProductData.code;
  ModalRef.componentInstance.price = this.inventoryProductData.price.value|| '100';
}
goToUpdatePersonalDetails(){

  this.router.navigate(['profile/my-account/update-personal-details']);
}
goToResetPassword(){

  this.router.navigate(['profile/my-account/change-password']);
}
inventorylogout(){
  sessionStorage.clear();
  this.router.navigate(['inventory/inventorylogin']);
}

}
